import m from 'mithril'

class OverlayText {
  view(vnode) {
    if (vnode.attrs.overlay.isImage)
    {
      return (
        <div className="overlay-text-wrapper">  
          <div id="test" className="overlay-text-container mod-instructions mod-center"> 
          
          {m.trust(vnode.attrs.overlay.text)}   
          </div> 
          <img className="overlay-text-image" src={vnode.attrs.overlay.src} 
          style={`${vnode.attrs.overlay.width ? 'width:'+vnode.attrs.overlay.width + '; height: auto;' : ''}`}/> 
          
        </div>
        
    )
    } 
    return (
        <div className="overlay-text-container mod-instructions">
        {m.trust(vnode.attrs.overlay.text)}          
      </div>
    )
  }
}

export default OverlayText
